module.exports = __webpack_public_path__ + "static/media/tmc-thumbnail.2c456ff5.png";